import httpClient from '@src/services/http.service'

export const state = {
  points: [],
  error: '',
}

export const actions = {
  init: ({ commit }) => {
    httpClient.get('object/point')
      .then(response => {
        commit('SET_POINTS', response.data)
      })
      .catch(error => {
        commit('SET_ERROR', error.message)
      })
  }
}

export const mutations = {
  SET_POINTS: (state, points) => {
    state.points = points.filter(point => point.status === 'published')
  },
  SET_ERROR: (state, error) => {
    state.error = error
  },
}

export const getters = {
  points: state => state.points,
  getPoint: state => slug => state.points.find(point => point.slug === slug),

  nearbyAttractions: state => point => {
    return state.points.filter(obj => {
      return point.objectsNearby.includes(obj._id)
    })
  },

  nextPoint: state => point => {
    const pointOrderNum = state.points.indexOf(point)
    if (point._id !== state.points[state.points.length - 1]._id && pointOrderNum >= 0) {
      return state.points[pointOrderNum + 1].slug
    }
  },

  previousPoint: state => point => {
    const pointOrderNum = state.points.indexOf(point)
    if (pointOrderNum > 0) {
      return state.points[pointOrderNum - 1].slug
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
